export default "__VITE_ASSET__dbcae7e9__"